import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { environment } from "../../../environments/environment";
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
declare var google;

@Component({
  selector: 'app-overview-tab',
  templateUrl: './overview-tab.component.html',
  styleUrls: ['./overview-tab.component.scss']
})
export class OverviewTabComponent implements OnInit {

  companyDetails: any = {};
  topLocations: any[] = [];
  companiesGaining: any[] = [];
  companiesLosing: any[] = [];
  school: any[] = [];
  fieldOfStudy: any[] = [];
  skills: any[] = [];
  titles: any[] = [];
  currentCompanyName: any;
  dataSourceWorkCountry: any = [];
  gross_additions_by_month: number = 0;
  hireDepartureTalentMovement: any = {};
  showSchoolLoader: boolean = true;
  alternatecompanyNames: any[] = []
  totalresultscount: any
  medianTanuresCount: any
  changedjobscount: any
  top_next_employers_by_role_images: any;

  abs(params: number) {
    return Math.abs(params);
  }
  subscriptions: Array<Subscription> = [];
  locationemptystate: Boolean = false;
  companyemptystate: Boolean = false;
  companylosingemptystate: Boolean = false;
  schoolemptystate: Boolean = false;
  fieldofstudyemptystate: Boolean = false;
  skillemptystate: Boolean = false;
  titlesemptystate: Boolean = false;
  companyinsightsFilter: any = {};
  medianTenureLoader: Boolean = false;

  /**
   * Object of Hire and Attrition
   * Keys of Recent Hires and Recent Attrition
   * Contains count and percentage
   */
  hiresAndAttritionObj: any = {};
  primaryCompanyInformation:any = {};


  constructor(
    private router: Router,
    private route: ActivatedRoute, 
    private personSearchService: PersonSearchService, 
    private companyInsightsService: CompanyInsightsService, 
    private location: Location,
    private localStorageService: LocalStorageService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService,
    private reqObjectHandlerService: AggReqObjectHandlerService,
    private aggReqObjHandler: AggReqObjectHandlerService,
  ) { }

  ngOnInit(): void {
    this.setCompanyDetails();
    this.fetchPageData(null);
    this.setGrossAdditionsByMonth();

    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);
  }

  private setCompanyDetails() {
    this.companyDetails = this.companyInsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
  }

  private fetchPageData(companyDetails?:any) {
    if(companyDetails)
    this.companyDetails = companyDetails;
    this.getTopLocations();
    this.getSchool();
    this.getFieldOfStudy();
    this.getSkills();
    this.getTitles();
    // this.getchangedjobcount();
    this.getcompanywinningTalentFrom();
    this.getcompanylosingtalentto();
    this.getGrowthRateAttrtionRateData();
    this.getMedianTanureCount();
  }

  private setGrossAdditionsByMonth() {
    if (this.companyDetails?.gross_additions_by_month) {
      const movementCompanies: [string, number][] = Object.entries(this.companyDetails.gross_additions_by_month);
      movementCompanies.forEach(([dateRaw, count]) => {
        const date = dateRaw + '-01';
        if (this.hireDepartureTalentMovement[date]) {
          this.hireDepartureTalentMovement[date].hireTalent = count;
          this.hireDepartureTalentMovement[date].totalTalent = this.hireDepartureTalentMovement[date]?.departureTalent + count;
        } else {
          this.hireDepartureTalentMovement[date] = {
            hireTalent: count,
            label: Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(new Date(date)),
            order: parseInt(date.replace(/-/g, ''), 10)
          };
        }
      });
    }
    this.gross_additions_by_month = Object.values(this.hireDepartureTalentMovement).sort((a: any, b: any) => a.order - b.order).slice(-12).map((x: any) => x.hireTalent).reduce((a, c) => a + c, 0);
  }

  getGrowthRateAttrtionRateData() {
    let request : AggregationRequest = new TIAggRequest();
    this.aggReqObjectHandlerService.setShareRequestObject(request);
    request = this.aggService.getRequestWithFilters();
    request.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(request);
    const data = {
      ...request,
      companies: this.alternatecompanyNames,
      
    };

    this.hiresAndAttritionObj = {};

    //Get company Attrition data
    this.personSearchService.getCompanyAttrition(data).subscribe((res: any) => {
      if (res && res.data) {
        const recentAttrtion = {
          "increaseRate": res.data?.increaseRate,
          "previousYearCount": res.data?.previousYearCount,
          "currentYearCount": res.data?.currentYearCount,
          "type": res.data?.type
        }
        this.hiresAndAttritionObj['recentAttrtion'] = recentAttrtion
      }
    })

    //Get company Growth Data
    this.personSearchService.getCompanyGrowth(data).subscribe((res: any) => {
      if (res && res.data) {
        const recentGrowth = {
          "increaseRate": res.data?.increaseRate,
          "previousYearCount": res.data?.previousYearCount,
          "currentYearCount": res.data?.currentYearCount,
          "type": res.data?.type
        }
        this.hiresAndAttritionObj['recentGrowth'] = recentGrowth;
      }
    })
  }

  getTopLocations() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "location";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.topLocations = response.data.aggregations.location.slice(0, 5);
      this.locationemptystate = true;
      this.totalresultscount = response.data.totalresultscount;
      const CharForworkCountry = [];
      CharForworkCountry.push(['Location', 'Professional count'])
      this.topLocations.slice(0, 10).forEach(x => {
        const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
        CharForworkCountry.push(dataObj);
      });
      this.dataSourceWorkCountry = CharForworkCountry;
      setTimeout(() => {
        this.loadGoogleMap();
      });
    });
  }

  getCompaniesGaining() {
    this.companiesGaining = Object.entries(this.companyDetails.top_next_employers_by_role.all).map(([key, value]) => ({ key, doc_count: value })).slice(0, 5);
    this.getCompaniesGainingLogo();

  }

  getCompaniesLosing() {
    this.companiesLosing = Object.entries(this.companyDetails.top_previous_employers_by_role.all).map(([key, value]) => ({ key, doc_count: value })).slice(0, 5);
    this.getCompaniesLosingLogo();
  }

  getSchool() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "school";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.school = response.data.aggregations.school.slice(0, 5);
      this.showSchoolLoader = false;
      this.schoolemptystate = true;
    });
  }

  getFieldOfStudy() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.fieldOfStudy = response.data.aggregations.fieldofstudy.slice(0, 5);
      this.fieldofstudyemptystate = true;
    });

  }

  getSkills() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "skills";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.skills = response.data.aggregations.skills.slice(0, 5);
      this.skillemptystate = true;
    });
  }

  getTitles() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "jobtitle";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.titles = response.data.aggregations.jobtitle.slice(0, 5);
      this.titlesemptystate = true;
    });
  }


  loadGoogleMap() {
    function drawMarkersMap() {
     var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
     var options = {
       region: 'world',
       displayMode: 'markers',
       colorAxis: { colors: ['#ff7f7f', '#ffff32', '#4292ff'] }
     };
     const container = document.getElementById('workCountryChart');
     var chart = new google.visualization.GeoChart(container);
     chart.draw(data, options);
   }

  //  if (this.isInsightsActive) {
     google.charts.load('current', {
       'packages': ['geomap', 'geochart'],
       'mapsApiKey': environment.mapskey
     });
     google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  //  }
 }

 getchangedjobcount() {
  let aggReq : AggregationRequest = new TIAggRequest();
  aggReq.aggregatetype = "changedjobs";
  this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
  aggReq = this.aggService.getRequestWithFilters();
  aggReq.companies = this.alternatecompanyNames;
  this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
  this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
   if(response.status == "success") {
    this.changedjobscount = response.data.aggregations && response.data.aggregations.changedjobs && response.data.aggregations.changedjobs.doc_count ?  response.data.aggregations.changedjobs.doc_count: 0;
   }
  });
 }

 getMedianTanureCount() {
  this.medianTenureLoader = true;
  let aggReq : AggregationRequest = new TIAggRequest();
  aggReq.aggregatetype = "total_tenure_median";
  aggReq.startindex = 0;
  aggReq.resultsize = 5;
  this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
  aggReq = this.aggService.getRequestWithFilters();
  aggReq.companies = this.alternatecompanyNames;
  this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

  this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((res:any) => {
    if(res.data && res.data.aggregations && res.data.aggregations.total_tenure_median){
      this.medianTenureLoader = false;
      this.medianTanuresCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
    }
  });

}

returnSpanTag(text) {
  let spanTag = document.createElement("span");
  spanTag.className='median-tenure-text-size';
  spanTag.innerHTML = text
  return spanTag;
}

getFormattedTenureForMatrix(tenure: number) {
  const totalYears = Math.floor(tenure);
  const totalMonths = Math.round((tenure - totalYears) * 12);
  if(tenure == null){
    return 0;
  }else if (totalYears > 0 && totalMonths > 0) {
    if(totalMonths == 12) {
      return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    }
  } else if (totalYears > 0 && totalMonths == 0) {
    return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
  } else if (totalYears == 0 && totalMonths > 0) {
    if(totalMonths == 12) {
      return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
    } else
    return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
  } else {
    return '';
  }
}

 getcompanywinningTalentFrom() {
  this.reqObjectHandlerService.setShareRequestObject(new TIAggRequest());
  const requestObject = this.aggService.getRequestWithFilters();
  requestObject.resultsize = 7;
  requestObject.startindex = 0;
  requestObject.aggregatescount = 5;
  requestObject.companies = this.alternatecompanyNames;
  requestObject.functiontype = 'Current';
  this.companyInsightsService.getcompanywinningTalentFrom(requestObject).subscribe((response) => {
   if(response.status == "success") {
    this.companiesGaining = response.aggregations.winningtalentfromcompany;
    this.companyemptystate = true;
   this.getCompaniesGainingLogo();
   }
  });
 }

 getcompanylosingtalentto() {
  this.reqObjectHandlerService.setShareRequestObject(new TIAggRequest());
  const requestObject = this.aggService.getRequestWithFilters();
  requestObject.resultsize = 7;
  requestObject.startindex = 0;
  requestObject.aggregatescount = 5;
  requestObject.companies = this.alternatecompanyNames;
  requestObject.functiontype = 'Current';

  this.companyInsightsService.getcompanylosingtalentto(requestObject).subscribe((response) => {
   if(response.status == "success") {
    this.companiesLosing = response.aggregations.losingtalenttocompany;
    this.companylosingemptystate = true;
   this.getCompaniesLosingLogo();
   }
  });
 }

 ngOnDestroy() {
  this.subscriptions.forEach(sub => sub.unsubscribe());
 }

 getCompaniesGainingLogo(){
    
  if(this.companiesGaining){
      let keys = this.companiesGaining.map(item => item.key);

      let dataNames = {
        companynames : keys
      }
      this.personSearchService.getCompanyLogo(dataNames).subscribe((res: any) => {
        if(res && res.status == "success"){
          const resultName = res.message
            resultName.forEach(obj => {
              const matchingObj = this.companiesGaining.find((item) => item.key === obj.key);
                  if (matchingObj) {
                      let companyLogo = obj.companylogo
                      matchingObj.companylogo = companyLogo;
                  }              
              });     
         }
      });

    }

  }


  getCompaniesLosingLogo(){
    if(this.companiesLosing){
      let keys = this.companiesLosing.map(item => item.key);
      let dataNames = {
        companynames : keys
      }
      this.personSearchService.getCompanyLogo(dataNames).subscribe((res: any) => {
        if(res && res.status == "success"){
          const resultName = res.message
            resultName.forEach(obj => {
              const matchingObj = this.companiesLosing.find((item) => item.key === obj.key);
                  if (matchingObj) {
                      let companyLogo = obj.companylogo
                      matchingObj.companylogo = companyLogo;
                  }              
            });     
        }
      });

    }

  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    const additionalFilters = {};
    switch(type) {
      case 'winningtalent': {
        additionalFilters['winningtalent'] = [key];
        additionalFilters['recentcompanyhires'] = true;
        break;
      } 
      case 'losingtalent': {
        additionalFilters['losingtalent'] = [key];
        additionalFilters['recentcompanyattrition'] = true; 
        break;
      }
      case 'location': additionalFilters['mandatorylocations'] = [key]; break;
      case 'company': additionalFilters['mandatorycompanies'] = [key]; break;
      case 'industry': additionalFilters['mandatoryindustries'] = [key]; break;
      case 'school': additionalFilters['mandatoryschools'] = [key]; break;
      case 'fieldofstudy': additionalFilters['mandatoryeducationalmajors'] = [key]; break;
      case 'skills': additionalFilters['mandatoryskills'] = [key]; break;
      case 'jobtitle': additionalFilters['mandatoryjobtitles'] = [key]; break;
    }
    this.companyinsightsFilter['additionalFilters'] = additionalFilters;
    this.companyinsightsFilter['name'] = this?.companyDetails?.name;
    this.companyinsightsFilter['alternative_names'] = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const requestObject = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}&keyword=${requestObject.booleanquery!= '*' ? requestObject.booleanquery: ''}`;
    window.open(url, "_blank");
  }


  getCompanyInfo(companyname){
    let companyData = {}
    companyData = {
      companynames: [companyname]
    }
    this.personSearchService.getCompanyLogo(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.message){
        let companyDetails = res.message[0]        
        this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
        this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
        this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
        this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
        this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
        this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['id'] = res.message[0].id
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['key_id'] = res.message[0].id  
      }
    });
  }

}
